import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivityInterface, WorkflowStepInterface } from '@vendasta/automata';
import { Observable, switchMap } from 'rxjs';
import { BrandingService } from '../../../../data-services/whitelabel.service';
import { ActivityTableEntry, AutomationDisplayService, NodeData } from '../../common/automation-display.service';

@Injectable({ providedIn: 'root' })
export class SmbUserVerifiedEmailService extends AutomationDisplayService {
  getActivityColumn(_namespace: string, _activity: ActivityInterface): ActivityTableEntry {
    return this.tableEntry(
      this.translateService.stream('AUTOMATIONS.EDITOR.TRIGGERS.EMAIL_VERIFIED.ACTIVITY_TITLE'),
      this.translateService.stream('AUTOMATIONS.EDITOR.TRIGGERS.EMAIL_VERIFIED.ACTIVITY_BODY'),
    );
  }

  getAutomationNodeData(
    namespace: string,
    _step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    return this.nodeDisplayData(
      this.brandingService
        .getBusinessAppName(namespace, '')
        .pipe(
          switchMap((businessAppName) =>
            this.translateService.stream('AUTOMATIONS.EDITOR.TRIGGERS.EMAIL_VERIFIED.TITLE', { businessAppName }),
          ),
        ),
      this.noValidationErrorsDetected(),
    );
  }

  constructor(
    protected readonly translateService: TranslateService,
    private readonly brandingService: BrandingService,
  ) {
    super();
  }
}
